export default class ConquestModel {
  constructor (data) {
    this.base = data.base
    this.aluno = data.aluno
  }
}
